import { render } from "./TermServiceDetail.vue?vue&type=template&id=062e17f8&scoped=true"
import script from "./TermServiceDetail.vue?vue&type=script&lang=js"
export * from "./TermServiceDetail.vue?vue&type=script&lang=js"

import "./TermServiceDetail.vue?vue&type=style&index=0&id=062e17f8&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062e17f8"]])

export default __exports__